module.exports = __webpack_public_path__ + "static/media/Haozhe Lin.1ca3fab9.jpg";